import axios from 'axios';

export default {
    getForPage(pageKey) {
        return axios.get('GetHintsForPage', {
            params: { page_key: pageKey }
        });
    },

    getAll() {
        return axios.get('Hint');
    },

    getById(id) {
        return axios.get(`Hint/${id}`);
    },

    save(hint) {
        if (hint.id) {
            return axios.put(`Hint/${hint.id}`, hint);
        }
    }
};
